import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        header: {
            display: 'flex',
            flexDir: 'column',
            alignItems: 'stretch',
            gap: remCalc(20),
            padding: {base: 'xsmall.base', sm: 'xsmall.base', md: 'small.base', lg: 'small.base'},
            paddingBottom: 'unset !important',
            background: 'background.neutral.default',
            maxWidth: 'unset',
        },
        headerContent: {
            width: '100%',
            display: 'flex',
            flexDir: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: remCalc(12),
        },
        headerText: {
            flex: 1,
            textStyle: 'body-medium',
            fontWeight: 'medium',
            color: 'foreground.neutral.default',
            background: 'background.neutral.default',
        },
        closeButton: {
            width: remCalc(36),
            height: remCalc(36),
            color: 'foreground.neutral.default',
            flexShrink: 0,
        },
        closeIcon: {
            width: remCalc(16),
            height: remCalc(16),
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        headerDivider: {
            width: '100%',
            height: remCalc(4),
            borderBottom: 'small',
            borderStyle: 'solid',
            borderColor: 'border.light',
            display: {base: 'none', sm: 'none', md: 'block', lg: 'block'},
            marginTop: 'small.base',
        },
        body: {
            paddingTop: 0,
            paddingBottom: 0,
            paddingX: {
                base: 'xsmall.base',
                sm: 'xsmall.base',
                md: 'small.base',
                lg: 'small.base',
            },
            background: 'background.neutral.default',
        },
        border: {
            width: '100%',
            height: remCalc(1),
            borderBottom: 'small',
            borderStyle: 'solid',
            borderColor: 'border.light',
            // marginBottom: {md: remCalc(22)},
        },
        footer: {
            display: 'block',
            width: 'full',
            height: 'auto',
            padding: ['small.base', 'small.md', 'small.lg', 'small.xl'],
            background: 'background.neutral.default',
            borderRadius: {base: 'unset', sm: 'unset', md: 'large-1', lg: 'large-1'},
            borderTop: 'small',
            borderStyle: 'solid',
            borderColor: 'border.light',
        },
        footerInnerContainer: {
            width: '100%',
            height: '100%',
            justifyContent: 'space-between',
            alignItems: 'center',
        },
    },
    variants: {
        freeItemPromo: {
            header: {
                maxWidth: '100%',
                width: '100%',
                justifyContent: 'flex-start',
                padding: {base: 'small.base', md: 'small.md', lg: 'small.lg', xl: 'small.xl'},
                height: 'auto',
            },
            headerMulti: {
                maxWidth: '100%',
                width: '100%',
                justifyContent: 'flex-start',
                height: 'auto',
                padding: {base: 'small.base', md: 'small.md', lg: 'small.lg', xl: 'small.xl'},
            },
            border: {
                borderBottom: 'unset',
            },
            titleContainer: {
                width: '100%',
                flexDir: 'row',
                paddingBottom: remCalc(0),
                justifyContent: 'space-between',
                alignItems: 'center',
                alignSelf: 'stretch',
            },
            titleContainerMulti: {
                width: '100%',
                flexDir: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
                alignSelf: 'stretch',
                paddingBottom: {base: remCalc(24), md: remCalc(40)},
            },
            closeButton: {
                width: remCalc(16),
                height: remCalc(16),
                position: 'relative',
                right: remCalc(0),
                flexShrink: 0,
            },
            progressBarContainer: {
                position: 'relative',
                height: remCalc(28),
                borderRadius: 'large',
                bg: 'background.base.under',
                alignItems: 'center',
                justifyContent: 'flex-start',
            },
            progressTextContainer: {
                display: 'flex',
                flexDir: 'row',
                justifyContent: 'flex-start',
                alignItems: 'center',
                gap: {base: 'xxsmall.base', md: 'xxsmall.md', lg: 'xxsmall.lg', xl: 'xxsmall.xl'},
                position: 'absolute',
                width: '100%',
                height: '100%',
                margin: {
                    base: 'xxsmall.base',
                    md: 'xxsmall.md',
                    lg: 'xxsmall.lg',
                    xl: 'xxsmall.xl',
                },
            },
            progressIcon: {
                width: remCalc(12),
                height: remCalc(12),
            },
            remainingText: {
                textStyle: 'body-xxsmall',
                fontWeight: 'bold',
            },
            drawerFooter: {
                display: 'block',
                width: 'full',
                height: 'auto',
                padding: {base: 'small.base', md: 'small.md', lg: 'small.lg', xl: 'small.xl'},
            },
        },
    },
}
